import { useLayoutEffect, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { scrollToTop } from '../../utils/scrollToTop';
import CaseStudyHero from './CaseStudyHero';
import CaseStudyIntro from './CaseStudyIntro';
import CaseStudyBody from './CaseStudyBody';
import CaseStudyProcess from './CaseStudyProcess';
import CaseStudyTech from './CaseStudyTech';
import CaseStudyNext from './CaseStudyNext';
import './CaseStudy.css';

const CaseStudyPage = ({ project }) => {
  useLayoutEffect(() => {
    scrollToTop();
  }, [project?.slug]);

  useEffect(() => {
    scrollToTop();
    const id = requestAnimationFrame(() => ScrollTrigger.refresh());
    return () => cancelAnimationFrame(id);
  }, [project?.slug]);

  if (!project) return null;

  const showTech = project.tech && project.tech.length > 0;

  return (
    <article
      key={project.slug}
      className={`case-study${project.mediaPresentation ? ` case-study--${project.mediaPresentation}` : ''}`}
      data-testid={`case-study-${project.slug}`}
    >
      <Link to="/work" className="cs-back" aria-label="Back to work index">
        ← Index
      </Link>

      <CaseStudyHero
        title={project.title}
        category={project.category}
        year={project.year}
        tagline={project.tagline}
        heroImage={project.heroImage}
        heroLayout={project.heroLayout}
        heroPlaceholder={project.heroPlaceholder}
        stripLabel={project.stripLabel}
        index={project.index}
        studioLine={project.studioLine}
      />

      <CaseStudyIntro
        meta={project.meta}
        intro={project.intro}
        variant={project.introVariant}
        header={project.introHeader}
        metaOrder={project.metaOrder}
        introNote={project.introNote}
      />

      {!project.processInBlocks && project.processNote && (
        <CaseStudyProcess
          text={project.processNote}
          paragraphs={project.processParagraphs}
          layout={project.processLayout}
        />
      )}

      <CaseStudyBody blocks={project.blocks} />

      {showTech && <CaseStudyTech items={project.tech} />}

      <CaseStudyNext
        key={`${project.slug}-${project.next?.slug ?? 'none'}`}
        next={project.next}
        label={project.nextLabel}
      />
    </article>
  );
};

export default CaseStudyPage;
